/** Мок API: волны и забежка. */
import { ApiError, sampleRunState } from "@newfungame/contracts";
import type { FakeDb, FakeHandlers } from "./db";

export function wavesHandlers(db: FakeDb): FakeHandlers<"submitWave" | "exitRun" | "revive" | "reviveBoost" | "live"> {
  return {
    submitWave: async (log) => {
      const cleared = log.result.outcome === "cleared";
      const nextWave = cleared ? log.wave + 1 : Math.max(1, log.wave - 1);
      db.state = {
        ...db.state,
        coins: db.state.coins + log.result.coins,
        bestWave: Math.max(db.state.bestWave, cleared ? log.wave : 0),
        run: { ...sampleRunState(nextWave), runId: db.state.run.runId },
        next: { wave: nextWave, seed: (log.seed * 1_103_515_245 + 12_345) >>> 0 },
      };
      return { verdict: "accepted", result: log.result, coinsAwarded: log.result.coins, state: db.fresh() };
    },
    live: async () => ({}),
    exitRun: async () => {
      db.state = { ...db.state, run: sampleRunState(db.state.run.wave) };
      return db.fresh();
    },
    revive: async () => db.fresh(),
    reviveBoost: async ({ index, boostId }) => {
      const picks = db.state.revivePicks;
      const option = picks?.options[index];
      if (!picks || option?.boostId !== boostId) throw new ApiError("conflict", "boost was not offered");
      // мок без движка: предложение не меняется, стаки и штаб не пересчитываются
      const boosts = [
        ...db.state.run.boosts.filter((x) => x.boostId !== boostId),
        { boostId, stacks: option.stacks + 1 },
      ];
      db.state = {
        ...db.state,
        run: { ...db.state.run, boosts },
        revivePicks: picks.left > 1 ? { ...picks, left: picks.left - 1 } : null,
      };
      return db.fresh();
    },
  };
}
